import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const checklistService = {
  search,
  getById,
  create,
  update,
  remove,
  postInteraction,
  getInteractions,
  getAllInteractions,
  getStats,
  syncFromPipeDrive,
  createTvDashboard,
  updateTvDashboard,
  getMyTvDashboards,
  toggleTvDashboard,
  revokeTvDashboard,
  verifyTvDashboardPassword,
  getTvDashboardData,
}

async function syncFromPipeDrive() {
  return await ApiBudgety.get('RequerimientoCliente/SyncFromPipeDrive', { headers })
}

const headers = {
  MENU: MenusSistema.checklist.id,
  ACCION: MenusSistema.checklist.accesos.gestionar,
}

async function search(page = 1, pageSize = 10, status = null) {
  let url = `RequerimientoCliente?page=${page}&pageSize=${pageSize}`
  if (status) {
    url += `&status=${encodeURIComponent(status)}`
  }
  return await ApiBudgety.get(url, { headers })
}

async function getById(id) {
  return await ApiBudgety.get(`RequerimientoCliente/${id}`, { headers })
}

async function create(body) {
  return await ApiBudgety.post('RequerimientoCliente', body, { headers })
}

async function update(id, body) {
  return await ApiBudgety.put(`RequerimientoCliente/${id}`, body, { headers })
}

async function remove(id) {
  return await ApiBudgety.delete(`RequerimientoCliente/${id}`, { headers })
}

async function postInteraction(requirementId, body) {
  return await ApiBudgety.post(`RequerimientoCliente/${requirementId}/interaction`, body, { headers })
}

async function getInteractions(requirementId) {
  return await ApiBudgety.get(`RequerimientoCliente/${requirementId}/interactions`, { headers })
}

async function getAllInteractions(page = 1, pageSize = 500) {
  return await ApiBudgety.get(`RequerimientoCliente/interactions/all?page=${page}&pageSize=${pageSize}`, { headers })
}

async function getStats(year = null, quarter = null, month = null) {
  let url = 'RequerimientoCliente/stats'
  const params = []
  if (year !== null) params.push(`year=${year}`)
  if (quarter !== null) params.push(`quarter=${quarter}`)
  if (month !== null) params.push(`month=${month}`)
  if (params.length > 0) {
    url += '?' + params.join('&')
  }
  return await ApiBudgety.get(url, { headers })
}

// --- TV Dashboards ---

async function createTvDashboard(body) {
  return await ApiBudgety.post('DashboardCompartido', body, { headers })
}

async function updateTvDashboard(id, body) {
  return await ApiBudgety.put(`DashboardCompartido/${id}`, body, { headers })
}

async function getMyTvDashboards() {
  return await ApiBudgety.get('DashboardCompartido', { headers })
}

async function toggleTvDashboard(id) {
  return await ApiBudgety.put(`DashboardCompartido/${id}/toggle`, {}, { headers })
}

async function revokeTvDashboard(id) {
  return await ApiBudgety.delete(`DashboardCompartido/${id}`, { headers })
}

// Estos dos métodos NO llevan headers de auth ya que son públicos para la TV
async function verifyTvDashboardPassword(id, password) {
  return await ApiBudgety.post(`DashboardCompartido/${id}/verify`, { password })
}

async function getTvDashboardData(id, sessionKey) {
  return await ApiBudgety.get(`DashboardCompartido/${id}/data`, {
    headers: { 'X-Session-Key': sessionKey },
  })
}
